import { BaseModel } from "../base.model";

export class AllFfTipoviFormiHeaderDto extends BaseModel {
    autoBr: number;
    sifra: number;
    naziv: string;
    aktivnaForma: boolean | null;
    autoFill: boolean | null;
    zabranaRemoteUnosa: boolean | null;
}